module.exports = __webpack_public_path__ + "static/media/Holiday-Savings-Slider-4.814c2ee1.jpg";